// themes.js
export const themes = {
  default: {
    name: 'Schools Advisory Service',
    primaryColor: '#2babe0',
    secondaryColor: '#2babe0',
    backgroundColor: '#2babe0',
    textColor: '#2babe0',
    backgroundImage: 'url(/images/wave.png)',
    logo: { url: '/images/sas-logo.png', alt: 'Schools Advisory Service Logo' },
    website: 'https://schooladvice.co.uk',
    privacy: 'https://schooladvice.co.uk/privacy',
    phone_number: { link: 'tel:01773814400', value: '01773814400' },
    email: 'mailto:sales@uk-sas.co.uk',
    staffAbsence: 'Staff Absence Policy',
    login: {
      title: 'One Portal for All Your Staff Absence and Wellbeing Needs',
      first: 'Realtime Claims and Payment Management',
      second: 'Comprehensive Wellbeing Resources and Tools',
      third: 'Complete Control Over Staff Data',
    },
    footer: {
      backgroundColor: '',
      textColor: '#364153',
      top: `
      <div className="mt-4 text-xs">
                  <p className="text-gray-600 font-medium">
                    Trigg House, 11 Maisies Way, South Normanton, Derbyshire, DE55
                    2DS
                  </p>
                <div>
                    <p className="text-gray-600 font-medium">
                      Schools Advisory Service | Registered in England No.
                      03475198 | Authorised and Regulated by the Financial Conduct
                      Authority (Reg No. 309701)
                    </p>
                </div>
              </div>
      `,
      bottom: '&copy; 2025 Schools Advisory Service. All rights reserved.',
    },
  },
  schoolsMutual: {
    name: 'Schools Mutual',
    primaryColor: '#8CCB94',
    secondaryColor: '#8CCB94',
    backgroundColor: '#8CCB94',
    textColor: '#8CCB94',
    backgroundImage: 'url(/images/wave-mutual.png)',
    logo: {
      url: '/images/schools-mutual-logo.png',
      alt: 'Schools Mutual Logo',
    },
    website: 'https://schoolsmutual.co.uk',
    privacy: 'https://schoolsmutual.co.uk/privacy',
    email: 'mailto:enquiries@schoolsmutual.co.uk',
    phone_number: { link: 'tel:01773851079', value: '01773851079' },
    staffAbsence: 'Staff Absence Agreement',
    login: {
      title: 'One Portal for All Your Staff Absence and Wellbeing Needs',
      first: 'Realtime Payment Request Management',
      second: 'Comprehensive Wellbeing Resources and Tools',
      third: 'Complete Control Over Staff Data',
    },
    footer: {
      backgroundColor: '',
      textColor: '#ffffff',
      top: `
        <div className="mt-4 text-xs">
                  <p className="text-gray-600 font-medium">
                  Schools Mutual, a trading name of SAS Mutual CIC (12499719) a: Trigg House, 11 Maisies Way, South Normanton, DE55 2DS. ICO License No: ZA757213
                  </p>
              </div>
      `,
      bottom:
        '© Schools Mutual, a trading name of SAS Mutual CIC – All Rights Reserved',
    },
  },
  coverAndCare: {
    name: 'Cover and Care',
    primaryColor: '#0a1e46',
    secondaryColor: '#d3ae36',
    backgroundColor: '#0a1e46',
    textColor: '#d3ae36',
    backgroundImage: 'url(/images/wave-cc-dark.png)',
    logo: {
      url: '/images/cover-and-care-logo.png',
      alt: 'Cover and Care Logo',
    },
    website: 'https://coverandcare.com',
    privacy: 'https://coverandcare.com/privacy',
    email: 'mailto:info@coverandcare.com',
    phone_number: { value: '+1615-266-6628', link: 'tel:+16152666628' },
    staffAbsence: 'Staff Absence Agreement',
    login: {
      title: 'One Portal for All Your Staff Absence and Wellbeing Needs',
      first: 'Realtime Payment Request Management',
      second: 'Comprehensive Wellbeing Resources and Tools',
      third: 'Complete Control Over Staff Data',
    },
    footer: {
      backgroundColor: '',
      textColor: '#364153',
      top: `

      `,
      bottom: '© Cover and Care. All Rights Reserved',
    },
  },
  sovriskManagement: {
    name: 'Sovereign Risk Management',
    primaryColor: '#E2A759',
    secondaryColor: '#3E3E3E',
    backgroundColor: '#3E3E3E',
    textColor: '#BF7C24',
    backgroundImage: 'url(/images/wave-srm.png)',
    logo: {
      url: '/images/srm-logo.png',
      alt: 'Sovereign Risk Management Logo',
    },
    website: 'https://sovriskmanagement.co.uk/',
    privacy: 'https://sovriskmanagement.co.uk/privacy',
    phone_number: { link: 'tel:01773814400', value: '01773814400' },
    email: 'mailto:sales@uk-sas.co.uk',
    staffAbsence: 'Staff Absence Policy',
    login: {
      title: 'One Portal for All Your Staff Absence and Wellbeing Needs',
      first: 'Realtime Claims and Payment Management',
      second: 'Comprehensive Wellbeing Resources and Tools',
      third: 'Complete Control Over Staff Data',
    },
    footer: {
      backgroundColor: '#313131',
      textColor: '#ffffff',
      top: `
      <div className="mt-4 text-xs">
                  <p class="text-white font-medium">
                    Trigg House, 11 Maisies Way, South Normanton, Derbyshire, DE55
                    2DS
                  </p>
                <div>
                    <p class="text-white font-medium">
                      Sovereign Risk Management Ltd. Registered in England No. 03475198 | Authorised and Regulated by the Financial Conduct Authority (Reg No. 309701)
                    </p>
                </div>
              </div>
      `,
      bottom: '&copy; 2025 Sovereign Risk Management. All rights reserved.',
    },
  },
}
